module.exports = __webpack_public_path__ + "static/media/ic_radio_off.07f6bda9.svg";